const orderGridItem = () => {
  const selectedValue = document.getElementById('SortBy').value;

        if (selectedValue === 'price-ascending' || selectedValue === 'price-descending') {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
    
            // Set or update the sort_by parameter
            params.set('sort_by', selectedValue);
    

            // Build the updated URL
            url.search = params.toString();
    
            // Redirect to the updated URL

             var elements = document.querySelectorAll(".loadGridAfterLoad");
              if (elements.length > 0) { } else {
                  window.location.href = url.toString();
              }
        }

          const productGridLoad2 = document.querySelector("ul#product-grid");

          if (!productGridLoad2) return;
        
          const items = Array.from(productGridLoad2.querySelectorAll("li[data-price]"));
        
          const isLowToHigh = productGridLoad2.classList.contains("lowtohigh");
          const isHighToLow = productGridLoad2.classList.contains("hightolow");
        
          if (!isLowToHigh && !isHighToLow) return;
        
          // Sort the <li> elements in desired order
          items.sort((a, b) => {
            const priceA = parseInt(a.getAttribute("data-price"), 10);
            const priceB = parseInt(b.getAttribute("data-price"), 10);
            return isLowToHigh ? priceA - priceB : priceB - priceA;
          });
        
          // Append each element back to the parent (it moves them instead of duplicating)
          items.forEach(item => productGridLoad2.appendChild(item));

        var elements = document.querySelectorAll(".loadGridAfterLoad");
        if (elements.length > 0) {
          elements.forEach(function(el) {
            el.classList.remove("loadGridAfterLoad");
          });
        }

}

const LoadGridItem = () => {
        const hiddenItems22 = document.querySelectorAll('ul#product-grid > li.SorthiddenItem');

        const observer22 = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const el22 = entry.target;
            if (entry.isIntersecting) {
              el22.classList.remove('SorthiddenItem');
              el22.classList.add('SortrevealedItem');
              observer22.unobserve(el22);
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        });
      
        hiddenItems22.forEach(el => observer22.observe(el));
}




class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    LoadMorePagination();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    LoadMorePagination();

    if (localStorage.getItem("hideReplacementDataOptions")) {
      document.querySelectorAll('.card_replacement_images').forEach(element => {
        let replacementImage = element.getAttribute('data-replacementimage');
        let imageElement = element.querySelector('img');

        if (imageElement && replacementImage) {
            imageElement.src = replacementImage;
            imageElement.srcset = replacementImage; 
        }
      });   

    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    console.log("ITG filter loaded 2");
    var elements = document.querySelectorAll(".loadGridAfterLoad");
        if (elements.length > 0) {
          elements.forEach(function(el) {
            el.classList.remove("loadGridAfterLoad");
          });
        }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    console.log("ITG filter loaded 1");
    var elements = document.querySelectorAll(".loadGridAfterLoad");
        if (elements.length > 0) {
          elements.forEach(function(el) {
            el.classList.remove("loadGridAfterLoad");
          });
        }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
     setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 1000);
      setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 2500);
      setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 5000);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);

      setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 1000);
      setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 2500);
      setTimeout (() => {
        orderGridItem();
        LoadGridItem();
      }, 5000);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);

    setTimeout (() => {
      orderGridItem();
      LoadGridItem();
    }, 1000);
    setTimeout (() => {
      orderGridItem();
      LoadGridItem();
    }, 2500);
    setTimeout (() => {
      orderGridItem();
      LoadGridItem();
    }, 5000);

  }
}

customElements.define('facet-remove', FacetRemove);



// ----------Load-More-pagination-----------//

function LoadMorePagination() {
  
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#productLoopPagination',
    method: 'click',
  });
 
    
  //  const productPages = document.querySelector("#product-grid");
  //  const loadMoreBtn = document.querySelector('.pagin-load-more-btn');
  //  let productUrl = productPages.getAttribute('data-pagin_url');
  //  const loadMoreIcon = loadMoreBtn.querySelector('.ctt_loademore_icon'); 
  //  loadMoreIcon.style.display = 'none'; 
  //  loadMoreBtn.addEventListener('click', function (e) {
  //    e.preventDefault();  
  //    loadMoreIcon.style.display = 'inline-block'; 
  //    fetch(productUrl, {
  //      method: 'GET',
  //      headers: { 'Content-Type': 'text/html' }
  //    })
  //      .then(response => response.text())
  //      .then(nextPage => { 
  //        loadMoreIcon.style.display = 'none'; 
  //        const parser = new DOMParser();
  //        const doc = parser.parseFromString(nextPage, 'text/html');
  //        const newProduct = doc.querySelector('#product-grid');
  //        const newProductUrl = newProduct.getAttribute('data-pagin_url');
  //        console.log(productUrl);
  //        console.log(newProductUrl+ ' = newProductUrl');
  //        if (newProductUrl) {
  //          loadMoreBtn.style.display = 'inline-block';
  //          loadMoreBtn.setAttribute('data-href', newProductUrl);
            
  //          productUrl = newProductUrl;
  //          productPages.insertAdjacentHTML('beforeend', newProduct.innerHTML);
  //        } 
          
  //      })
  //      .catch(error => {
  //        console.error('Error loading more products:', error);
  //      });
  //  }); 




  // /* ---------------- filter Option Hide according to brandName ==> START --------------------- */

  const url = window.location.href.toLowerCase();

  const hideMap = {
    costa: [
      'details[id*="lens_options_sunberryrx_-template"]',
      'details[id*="lens_options_oakley_-template"]',
      'details[id*="lens_options_rayban_-template"]'
    ],
    oakley: [
      'details[id*="lens_options_sunberryrx_-template"]',
      'details[id*="lens_options_costa_-template"]',
      'details[id*="lens_options_rayban_-template"]'
    ],
    rayban: [
      'details[id*="lens_options_sunberryrx_-template"]',
      'details[id*="lens_options_costa_-template"]',
      'details[id*="lens_options_oakley_-template"]'
    ],
    sunberryrx: [
      'details[id*="lens_options_costa_-template"]',
      'details[id*="lens_options_oakley_-template"]',
      'details[id*="lens_options_rayban_-template"]'
    ]
  };



  // Detect brand from URL

  let brand = 'sunberryrx';
  
  if (/collections\/prescription-sunglasses|collections\/all/.test(url)) {
    // console.log("yes all")
  } else {
    // console.log("not all")
    if (/costa/.test(url)) brand = 'costa';
    else if (/oakley/.test(url)) brand = 'oakley';
    else if (/rayban/.test(url)) brand = 'rayban';
  }


  // Hide unwanted sections
  hideMap[brand].forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('filterOptionToHide');
    });
  });

  // Show matching brand sections
  document.querySelectorAll(`details[id*="lens_options_${brand}_-template"]`).forEach(el => {
    el.classList.add('filterOptionToShow');
  });

  // --- Always clean labels: remove [brand]-style tags and (number) counts ---
  const cleanLabels = (root = document) => {
    const labels = root.querySelectorAll('.filter_label_to_edit');

    // Remove any square-bracketed text and any "(number)" counts
    const bracketedAny = /\s*\[[^\]]*\]\s*/g;   // e.g., " [Sunberryrx]" or " [Ray-Ban]"
    const countPattern = /\s*\(\s*\d+\s*\)\s*/g; // e.g., " (0)" or " (12)"

    labels.forEach(label => {
      const cleaned = label.textContent
        .replace(bracketedAny, '')
        .replace(countPattern, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
      label.textContent = cleaned;
    });
  };

  cleanLabels();


  // --- Append matching li items to filterOptionToShow ---

  const moveMatchingItems = () => {
    const hideElements = document.querySelectorAll('.facets-vertical details.js-filter.filterOptionToHide');
    const showElements = document.querySelectorAll('.facets-vertical details.js-filter.filterOptionToShow');

    hideElements.forEach(hideEl => {
      const hideListItems = hideEl.querySelectorAll('.list-menu__item.facets__item');
      
      showElements.forEach(showEl => {
        const showListItems = showEl.querySelectorAll('.list-menu__item.facets__item');

        hideListItems.forEach(hideItem => {
          const hideItemLabel = hideItem.querySelector('.facet-checkbox__text-label')?.textContent.trim();
          if (!hideItemLabel) return;  // Skip if no label exists
          
          let itemMatched = false;

          showListItems.forEach(showItem => {
            const showItemLabel = showItem.querySelector('.facet-checkbox__text-label')?.textContent.trim();
            if (!showItemLabel) return;  // Skip if no label exists

            // Compare text content of the label, if matched skip
            if (hideItemLabel === showItemLabel) {
              itemMatched = true;
            }
          });

          // If not matched, append to the show list
          if (!itemMatched) {
            const showUl = showEl.querySelector('fieldset ul');
            if (showUl) { // Check if the UL exists before appending
              showUl.appendChild(hideItem);
            }
          }
        });
      });
    });

    // Now sort the list of items in the "show" list
    sortItemsAlphabetically();
  };
  
  // Function to sort the items alphabetically after they've been moved
  const sortItemsAlphabetically = () => {
    const showElements = document.querySelectorAll('.facets-vertical details.js-filter.filterOptionToShow');

    showElements.forEach(showEl => {
      const showList = showEl.querySelector('fieldset ul');

      if (showList) {
        const listItems = Array.from(showList.querySelectorAll('.list-menu__item.facets__item'));

        // Sort the list items alphabetically based on the label text
        listItems.sort((a, b) => {
          const labelA = a.querySelector('.facet-checkbox__text-label')?.textContent.trim() || '';
          const labelB = b.querySelector('.facet-checkbox__text-label')?.textContent.trim() || '';
          return labelA.localeCompare(labelB);  // Compare labels alphabetically
        });

        // After sorting, re-append them in the sorted order
        listItems.forEach(item => {
          showList.appendChild(item);
        });
      }
    });
  };

  moveMatchingItems();  
  
  // ---------------- filter Option Hide according to brandName ==> END ---------------




}LoadMorePagination();
 
